import React from 'react';
import PropTypes from 'prop-types';
import { GenTeaser, SidebarHeading, DecorativeLink } from '@massds/mayflower-react';
import DangerousWrapper from '../DangerousWrapper';

const PressRelease = (props) => {
  const {
    date, title, link, description
  } = props;
  return(
    <div className="sidebar__related">
      <SidebarHeading level={2} title="Related" />
      <GenTeaser>
        <GenTeaser.Details>
          <GenTeaser.Eyebrow eyebrow="press-release" />
          <GenTeaser.Title title={{ icon: null }} level={3}>
            <DecorativeLink info={title} text={title} href={link} />
          </GenTeaser.Title>
          <GenTeaser.Emphasis>
            <GenTeaser.Date date={date} />
          </GenTeaser.Emphasis>
          <GenTeaser.Description>
            <DangerousWrapper rawHtml={description} htmlTag="p" />
          </GenTeaser.Description>
        </GenTeaser.Details>
      </GenTeaser>
    </div>
  );
};

PressRelease.propTypes = {
  /** the date associated with the press release publication. * */
  date: PropTypes.string,
  /** the title of the press release * */
  title: PropTypes.string,
  /** a full (not relative) link to the press release page * */
  link: PropTypes.string,
  /** a short summary description of the press release, this can include html tags * */
  description: PropTypes.string
};

export default PressRelease;
